import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import '../css/App.output.css';
import client, { currentBusinessIdVar } from '../wf/client';
import { ApolloProvider } from '@apollo/client';
import { BrandScreen } from '@withfriendsco/wf-components';
import { MixpanelProvider, useMixpanel } from 'react-mixpanel-browser';
import { Provider as RollbarProvider, ErrorBoundary as RollbarErrorBoundary } from '@rollbar/react';
import { BrowserRouter as Router } from 'react-router-dom';
const rollbarConfig = {
    accessToken: '91124c51aa0c42968e3378eee144e8df',
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.NODE_ENV === "development" ? "development" : "production",
};
const BrandApp = ({ id, fromPreOnboarding, standalone = false }) => {
    currentBusinessIdVar(id);
    const mixpanel = useMixpanel();
    useEffect(() => {
        if (!mixpanel)
            return;
        // Tracks users who come to this site when they already have a cookie set on withfriends.co
        if (mixpanel.get_distinct_id().indexOf("@") === -1) {
            document.cookie = `wf-lm-id=${mixpanel.get_distinct_id()};domain=.withfriends.co;secure;path=/`;
        }
    }, [mixpanel]);
    return (_jsx(RollbarProvider, { config: rollbarConfig, children: _jsx(RollbarErrorBoundary, { fallbackUI: () => _jsx("div", { children: "Something went wrong, and our team has been alerted. Try refreshing, or reach out to support@withfriends.co for help" }), children: _jsx(ApolloProvider, { client: client, children: _jsx(MixpanelProvider, { token: process.env.REACT_APP_MIXPANEL_KEY, children: _jsx(Router, { children: _jsx("div", { id: "tw-root", children: _jsx("div", { id: "tw-main", className: "App container-fluid", children: _jsx(BrandScreen, { fromPreOnboarding: fromPreOnboarding, standalone: standalone }) }) }) }) }) }) }) }));
};
export default BrandApp;
